import { render, staticRenderFns } from "./add-value-service.vue?vue&type=template&id=c98d3fe8"
import script from "./add-value-service.vue?vue&type=script&lang=ts"
export * from "./add-value-service.vue?vue&type=script&lang=ts"
import style0 from "./add-value-service.vue?vue&type=style&index=0&id=c98d3fe8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports